import { trpc } from '@/shared/api';

interface ProductionOrderSheetQueryOptions {
  readonly enabled?: boolean;
}

/** 어드민 발주서 조회(orderManagement.getProductionOrderSheet) — 저장본(없으면 null)·기본값·제작 정보. */
export const useProductionOrderSheetQuery = (
  orderId: string,
  options: ProductionOrderSheetQueryOptions = {},
) =>
  trpc.orderManagement.getProductionOrderSheet.useQuery(
    { orderId },
    {
      enabled: options.enabled ?? true,
      // 없는 주문(ORDER_NOT_FOUND)은 재시도해도 같다.
      retry: false,
    },
  );
